import { Page } from 'components/page';
import { TaplioLevel } from '../../components/dashboard/taplio-level';
import * as analytics from 'utils/analytics';
import { Box, Flex, useMediaQuery } from '@chakra-ui/react';
import { useSession } from 'next-auth/react';
import { SsiScore } from 'components/ssi-score/ssi-score';
import ProtectedRoute from 'components/protected-route';
import { DraftTable } from 'components/dashboard/draft-table';
import { TopPostsTable } from 'components/dashboard/top-posts';
import { AiSuggestionsCard } from 'components/dashboard/ai-suggestions-card';
import { DashboardTeasers } from 'components/dashboard/dashboard-teasers';
import { EngageWithComments } from 'components/dashboard/engage-comments';
import { useEffect, useState } from 'react';
import { useTweetContext } from 'context/tweetContext';

const Dashboard = () => {
  const { data: session, status } = useSession() ?? {};
  const [minWidthWithSidebar] = useMediaQuery('(min-width: 1540px)');
  const [minWidthWithComposer] = useMediaQuery('(min-width: 1740px)');
  const [minWidthWithSidebarComposer] = useMediaQuery('(min-width: 1940px)');
  const [navSize, setNavSize] = useState<'small' | 'large'>('small');
  const tweetContext: any = useTweetContext();
  const directionArr: ('row' | 'column')[] = [
    'column',
    'column',
    'column',
    'column',
    'row',
  ];
  const [dynamicContainerDirection, setDynamicContainerDirection] = useState<
    ('row' | 'column')[] | ('row' | 'column')
  >(directionArr);
  const loading = status === 'loading';

  useEffect(() => {
    if (session && session?.user) {
      analytics.log('dashboard_viewed');
    }
  }, [session]);

  useEffect(() => {
    if (navSize === 'small' && !tweetContext.isOpen) {
      // Small nav size and no composer
      setDynamicContainerDirection(directionArr);
    } else if (navSize === 'large' && tweetContext.isOpen) {
      // Large nav size and composer is open
      if (minWidthWithSidebarComposer) {
        setDynamicContainerDirection('row');
      } else {
        setDynamicContainerDirection('column');
      }
    } else if (navSize === 'large') {
      // Large nav size and no composer
      if (minWidthWithSidebar) {
        setDynamicContainerDirection('row');
      } else {
        setDynamicContainerDirection('column');
      }
    } else if (tweetContext.isOpen) {
      // Small nav size and composer is open
      if (minWidthWithComposer) {
        setDynamicContainerDirection('row');
      } else {
        setDynamicContainerDirection('column');
      }
    }
  }, [
    minWidthWithSidebarComposer,
    minWidthWithSidebar,
    tweetContext.isOpen,
    navSize,
  ]);

  if (!(loading || (session && session?.user))) {
    return <ProtectedRoute />;
  }

  return (
    <Page
      title={`Hi! ${
        session?.user?.name ? `${session?.user?.name}.` : ''
      } Welcome back.`}
      forceCloseScheduler
      mainWrapperProps={{ maxW: 1400 }}
      setNavSize={setNavSize}
    >
      <Flex direction='column' gap={6}>
        <Flex gap={4} pt={6} direction={dynamicContainerDirection}>
          <SsiScore />
          <TaplioLevel />
        </Flex>
        <Flex>
          <EngageWithComments />
        </Flex>
        <Flex gap={6} direction={['column', 'column', 'column', 'row']}>
          <DashboardTeasers />
        </Flex>
        <Flex>
          <DraftTable />
        </Flex>
        <Flex>
          <TopPostsTable />
        </Flex>
        <Flex>
          <AiSuggestionsCard />
        </Flex>
      </Flex>
    </Page>
  );
};

export default Dashboard;
